var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hearder"},[_c('div',{staticClass:"app-wrapper top"},[_c('h1',{on:{"click":function () {
          _vm.$router.push({ path: '/' })
        }}},[_c('img',{attrs:{"src":require("../../assets/logo.png")}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.COMPET_NAME))])]),_vm._v(" "),(!_vm.isMobileDevice)?_c('Nav',{staticClass:"nav_mod"}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6080b91c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/components/hearder.vue
// module id = null
// module chunks = 